import React from 'react';

export default function ConfirmDialog({ open, title, message, confirmLabel = 'Confirm', onConfirm, onCancel, danger = false }) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-overlay backdrop-blur-sm flex items-center justify-center z-[300] animate-fade-in p-4" onClick={onCancel}>
      <div
        className="w-full max-w-[400px] bg-elevated rounded-xl border border-theme shadow-2xl animate-modal-in"
        onClick={e => e.stopPropagation()}
      >
        <div className="px-6 py-5">
          <h3 className="text-[16px] font-bold text-primary-c mb-2">{title}</h3>
          <p className="text-[13px] text-secondary-c">{message}</p>
        </div>
        <div className="flex justify-end gap-2.5 px-6 py-4 border-t border-theme">
          <button
            onClick={onCancel}
            className="px-4 py-2 rounded-[10px] text-[13px] font-semibold text-primary-c bg-tertiary border border-theme hover:bg-hover-surface transition-all"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className={`px-4 py-2 rounded-[10px] text-[13px] font-semibold text-white transition-all ${
              danger
                ? 'bg-[var(--danger)] hover:opacity-90'
                : 'gradient-accent shadow-glow hover:shadow-glow-lg'
            }`}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
